import { useState } from 'react';

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}(T[\d:+.Z]+)?$/;

function compare(a, b, dir) {
  if (a == null && b == null) return 0;
  if (a == null) return dir === 'asc' ? -1 : 1;
  if (b == null) return dir === 'asc' ? 1 : -1;
  // ISO date / datetime strings — compare as timestamps
  if (ISO_DATE_RE.test(String(a)) && ISO_DATE_RE.test(String(b))) {
    const ta = new Date(a).getTime();
    const tb = new Date(b).getTime();
    return dir === 'asc' ? ta - tb : tb - ta;
  }
  const numA = parseFloat(a);
  const numB = parseFloat(b);
  if (!isNaN(numA) && !isNaN(numB)) {
    return dir === 'asc' ? numA - numB : numB - numA;
  }
  const strA = String(a).toLowerCase();
  const strB = String(b).toLowerCase();
  return dir === 'asc' ? strA.localeCompare(strB) : strB.localeCompare(strA);
}

export default function useSortable(defaultKey = '', defaultDir = 'desc') {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [sortDir, setSortDir] = useState(defaultDir);

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  const sortData = (data, accessor) => {
    if (!sortKey || !data?.length) return data ?? [];
    return [...data].sort((a, b) => {
      const aVal = accessor ? accessor(a, sortKey) : a[sortKey];
      const bVal = accessor ? accessor(b, sortKey) : b[sortKey];
      return compare(aVal, bVal, sortDir);
    });
  };

  return { sortKey, sortDir, handleSort, sortData };
}
